<template>
  <div class="suggestion">
    <div class="post_form">
      <div class="post_input">
        <input
          type="text"
          v-model="info.tel"
          placeholder="请输入您的联系方式（手机或邮箱）"
        />
      </div>
      <div class="form_1">
        <textarea
          class="textarea"
          v-model="info.writing"
          maxlength="150"
          placeholder="请输入您遇到的问题，或是对我们产品的任何意见。（建议字数1-150字）"
        />
      </div>
      <div class="img_list">
        <div
          class="img_item"
          v-for="(item, index) in info.imgJson"
          :key="index"
          @click="delImg($event)"
          :data-index="index"
          :style="{
            backgroundImage: 'url(' + www + item.thumbfilepath + ')'
          }"
        >
          <img class="delete" src="../../static/circle/icon_10.png" />
          <img :src="item.thumbfilepath" class="img" />
        </div>
        <div
          class="img_item"
          @click="setImgarr"
          v-show="info.imgJson.length < 9"
        >
          <img class="item_icon" src="../../static/circle/icon_12.png" />
        </div>
      </div>
      <div class="btn_save" @click="btn_save">提交</div>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import { MessageBox, Toast } from "mint-ui";
import { getsuggest } from "../view/api/api"; //引入api里面定义的方法
let inputElement = null;
import axios from "axios";
export default {
  props: ["www", "apiurl"],
  data() {
    return {
      info: {
        imgJson: [],
        tel: "",
        writing: ""
      }
    };
  },

  methods: {
    setImgarr() {
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }

        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    uploadFile(el) {
      var _self = this;
      var loadingInstance1 = Loading.service({ fullscreen: true });
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 50;
        const size = files.size / 1024 / 1024;
        //console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$toast("上传图片大小不能超过 50MB!");
          that.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance1.close();
          });
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$toast("请选择图片文件");
          that.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance1.close();
          });
        } else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          console.log(el.target.files[0]);
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function() {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.valueUrl = this.result;
            //console.log(_self.dataURLtoBlob(this.result));

            // 数据传到后台
            const formData = new FormData();
            formData.append("suggestimg", files, files.name); // 通过append向form对象添加数据,可以通过append继续添加数据//或formdata1.append('img',file);
            let config = {
              headers: { "Content-Type": "multipart/form-data" }
            };
            axios
              .post(that.apiurl + "/uploadSuggestImg", formData, config)
              .then(uploadFileRes => {
                console.log(uploadFileRes.data);
                //var res = JSON.parse(uploadFileRes.data);
                //console.log(res.data);
                var res = uploadFileRes.data;
                console.log(res);
                if (res.status == 1) {
                  that.info.imgJson.push(uploadFileRes.data.data);
                } else {
                  that.$toast(res.msg);
                }
                that.$nextTick(() => {
                  // 以服务的方式调用的 Loading 需要异步关闭
                  loadingInstance1.close();
                });

                inputElement = null;
              });
          };
        }
      }
    },
    delImg(e) {
      //console.log(e)
      var _self = this;
      var index = e.currentTarget.dataset.index;

      MessageBox.confirm("是否删除图片")
        .then(action => {
          Toast({
            message: "删除成功"
          });
          var imgJson = _self.info.imgJson;
          imgJson.splice(index, 1);
          _self.info.imgJson = imgJson;
        })
        .catch(() => {
          Toast({
            message: "已取消删除"
          });
        });
    },

    async btn_save() {
      var _self = this;
      var data = _self.info;
      //console.log(data);
      var reg = /^1[34578][0-9]{9}/;
      var reg1 = /[a-zA-Z0-9]{1,10}@[a-zA-Z0-9]{1,5}\.[a-zA-Z0-9]{1,5}/;
      if (data.tel == "") {
        this.$toast("请输入手机号码或邮箱");
        return false;
      } else {
        if (!reg.test(data.tel) && !reg1.test(data.tel)) {
          this.$toast("请正确填写手机号码或邮箱！");
          //$(".input_login_name").val("");
          return false;
        }
      }
      if (data.writing == "") {
        this.$toast("请输入您遇到的问题");

        return false;
      }

      var parm = {
        writing: data.writing,
        imgJson: JSON.stringify(data.imgJson),
        tel: data.tel
      };
      const res = await getsuggest(parm);

      if (res.status == 1) {
        this.$toast({
          message: "提交成功",
          type: "success"
        });
        _self.info.imgJson = [];
        _self.info.writing = "";
        _self.info.tel = "";
        //_self.dialog = false;
        let data = {
          dialog: false
        };
        this.$emit("suggclose", data);
      } else {
        this.$toast(res.msg);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.suggestion {
  .post_form {
    flex-direction: column;
    .post_input {
      width: 100%;
      height: auto;
      padding: 0.19rem 0.2rem;
      background: #f9f9f9;
      border-radius: 0.2rem;
      margin-bottom: 0.3rem;
      input {
        width: 100%;
        height: 100%;
        font-size: 0.16rem;
        color: #333333;
        border: 0;
        background: transparent;
        @media (max-width: 991px) {
          font-size: 0.28rem;
        }
      }
    }
    .form_1 {
      width: 100%;
      padding: 0.2rem;
      background: #f9f9f9;
      flex-direction: column;
      margin-bottom: 0.3rem;
      border-radius: 0.2rem;
      .textarea {
        width: 100%;
        font-size: 0.16rem;
        color: #1b1c33;
        line-height: 0.33rem;
        height: 1.4rem;
        border: 0;
        background: transparent;
        resize: none;
        @media (max-width: 991px) {
          font-size: 0.28rem;
        }
      }
      .foot {
        .btn_item {
          align-items: center;
          margin: 0 0.15rem 0 0.15rem;
          .ti_icon {
            width: 0.22rem;
            height: 0.22rem;
            margin-right: 0.05rem;
          }
          padding: 0 0.17rem;
          line-height: 0.42rem;
          height: 0.42rem;
          border-radius: 0.21rem;
          border: 0.01rem solid #1395ff;
          font-size: 0.26rem;
          color: #1395ff;
        }
      }
    }
    .img_list {
      width: 100%;
      padding: 0.22rem 0.2rem 0 0.2rem;
      height: auto;
      overflow: hidden;
      background: #f9f9f9;
      border-radius: 0.2rem;
      flex-wrap: wrap;
      display: flex;
      .img_item {
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 0.1rem;
        margin-right: 0.2rem;
        margin-bottom: 0.3rem;
        background-color: #ffffff;
        align-items: center;
        justify-content: center;
        border: 0.01rem solid #979797;
        position: relative;
        background-position: center;
        background-size: cover;
        display: flex;
        @media (max-width: 991px) {
          width: 1.2rem;
          height: 1.2rem;
        }
        .delete {
          position: absolute;
          top: -0.15rem;
          right: -0.15rem;
          width: 0.2rem;
          height: 0.2rem;
          @media (max-width: 991px) {
            width: 0.4rem;
            height: 0.4rem;
          }
        }
        .img {
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 0.06rem;
          opacity: 0;
          @media (max-width: 991px) {
            width: 0.8rem;
            height: 0.8rem;
          }
        }
        .item_icon {
          width: 0.3rem;
          height: 0.3rem;
          @media (max-width: 991px) {
            width: 0.5rem;
            height: 0.5rem;
          }
        }
        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }

    .btn_save {
      margin: 0.3rem auto 0.3rem auto;
      width: 2.7rem;
      height: 0.6rem;
      line-height: 0.6rem;
      background: #1395ff;
      border-radius: 0.3rem;
      font-size: 0.2rem;
      color: #ffffff;
      text-align: center;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      @media (max-width: 991px) {
        font-size: 0.28rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/suggestion.vue